module.exports = __webpack_public_path__ + "img/elementor.96cd31de.svg";